module.exports = "pegasus/assets/rectoutline-twitter.png";